import styled from 'styled-components';

import { gridSizes, media } from 'utils/style';

import Header from 'components/AddressModal/Header';
import AddressModal from 'components/AddressModal/component';

export const AddressModalHeaderStyled = styled(Header)`
  font-weight: 500;
`;

export default styled(AddressModal)`
  padding: ${gridSizes('L')};

  .floating {
    width: 100%;

    .content {
      margin: 0;
      border-radius: 0;
      padding-bottom: 0;
    }
  }

  ${media.lessThan('extraSmall')`
    padding: ${gridSizes('M')};
    display: flex;
    flex-direction: column;
    flex: 1;
    background: #fff;
  `};
  padding-bottom: 0px;

  .zipcode-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--grey700);

    .error {
      width: 240px;
      &-24h {
        width: 100%;
      }
    }

    & .cell {
      display: flex;
      width: 100%;
      justify-content: space-between;

      > div {
        &:not(.error) {
          width: 140px;
        }
      }
    }

    & .cell:last-child {
      line-height: normal;
    }
  }

  .city-name {
    color: var(--grey700);
    margin-bottom: ${gridSizes('M')};
  }

  .field-container {
    margin-bottom: ${gridSizes('M')};
    position: relative;
  }

  .cancel-btn {
    margin-top: 12px;

    button {
      background-color: #ffe0e2;
      color: #cc000a;

      &:hover {
        background-color: #fdafb3;
      }
    }
  }
`;
